import { combineReducers } from "redux"
import creationReducer from "./creation/reducer"
import currentReducer from "./current/reducer"

export const paymentsStateReducer = combineReducers({
  creation: creationReducer,
  current: currentReducer,
})
